import { render, staticRenderFns } from "./GridChatWindowManager.vue?vue&type=template&id=e5c70766&scoped=true"
import script from "./GridChatWindowManager.vue?vue&type=script&lang=js"
export * from "./GridChatWindowManager.vue?vue&type=script&lang=js"
import style0 from "./GridChatWindowManager.vue?vue&type=style&index=0&id=e5c70766&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c70766",
  null
  
)

export default component.exports